module.exports = __webpack_public_path__ + "img/make-brushes-2_en.43cf515.jpg";